import { useTranslation } from 'react-i18next'
import { ListChecks } from 'lucide-react'
import { TabsContent, TabsTrigger } from '@/components/ui/tabs'
import { useHierarchyAccess } from '../access'
import { HierarchyAdvisorPanel } from './HierarchyAdvisorPanel'

/**
 * The object page's "Review" tab: the advisor's panel with this service as the root (29 Sep 2026).
 * Services only - a service is what the advisor reviews beneath - and only for `hierarchy.review`
 * holders. Trigger and content are gated the same way so neither can appear without the other.
 */
export const OBJECT_REVIEW_TAB = 'hierarchyReview'

function useShowReviewTab(isService: boolean) {
    const { canReview } = useHierarchyAccess()
    return isService && canReview
}

export function ObjectReviewTabTrigger({ isService, className }: { isService: boolean; className?: string }) {
    const { t } = useTranslation()
    const show = useShowReviewTab(isService)
    if (!show) return null
    return (
        <TabsTrigger value={OBJECT_REVIEW_TAB} className={className}>
            <ListChecks className="mr-2 h-4 w-4 text-blue-600" />
            {t('hierarchyAdvisor.objectTab')}
        </TabsTrigger>
    )
}

export function ObjectReviewTabContent({
    isService,
    root,
    scenario,
}: {
    isService: boolean
    root: string
    scenario: string | number
}) {
    const show = useShowReviewTab(isService)
    if (!show || !root) return null
    return (
        <TabsContent value={OBJECT_REVIEW_TAB} className="px-4 py-4">
            <div className="max-w-2xl">
                <HierarchyAdvisorPanel root={root} scenario={scenario} />
            </div>
        </TabsContent>
    )
}
